module.exports = __webpack_public_path__ + "Roboto-Bold.896bd827e8e82ff22b27.ttf";


//////////////////
// WEBPACK FOOTER
// /revet-web/src/assets/fonts/Roboto-Bold.ttf
// module id = ../../../../../src/assets/fonts/Roboto-Bold.ttf
// module chunks = styles